exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spoiler-warning[data-v-40aa9962]{color:red;font-weight:700}.mystery[data-v-40aa9962]{font-weight:700}", ""]);

// exports
